import { render } from "./footer.vue?vue&type=template&id=71c4216a&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=71c4216a&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-71c4216a"

export default script